<span
  matTooltip="{{ tooltipText }}"
  matTooltipDisabled="{{ disabled }}"
  matTooltipPosition="{{ position }}"
  matTooltipShowDelay="{{ showDelay }}"
  matTooltipHideDelay="{{ hideDelay }}"
>
  <ng-content></ng-content>
</span>
